import React from 'react';
import Section, { FadeIn } from './ui/Section';

const faqs = [
  {
    q: "Is this really free?",
    a: "Yes. 100% free. No credit card required. Instant PDF download. We ask for your email so we can send you the guide and (optionally) share more translations later. Unsubscribe anytime."
  },
  {
    q: "Is this only for straight couples?",
    a: "No. While some translations reference common gender patterns, the framework works for any relationship where two people misunderstand each other. The principles are universal."
  },
  {
    q: "What if my partner won't read it?",
    a: "This guide works even if only you read it. Use the scripts unilaterally. Watch how your changed responses transform the conversation. Many readers report their partner asking \"what happened to you?\" — opening the door to share."
  },
  {
    q: "Is this therapy?",
    a: "No. This is practical communication education — specific translations for specific moments. If you're in abuse, addiction, or severe mental health crisis, please see a professional. This guide is for relationships that are good but confusing."
  },
  {
    q: "What format is it?",
    a: "PDF. 14 pages. Works on phone, tablet, computer, or print. Instant download."
  }
];

const FAQ = () => {
  return (
    <Section className="bg-white">
      <div className="max-w-3xl mx-auto">
        <FadeIn>
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16">
            Questions? We've Got Answers
          </h2>
        </FadeIn>

        <div className="space-y-8">
          {faqs.map((faq, i) => (
            <FadeIn key={i} delay={i * 0.1}>
              <div className="border-b border-gray-200 pb-8">
                <h3 className="text-xl font-bold text-brand-dark mb-3">{faq.q}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.a}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default FAQ;